'use client';

import { useEffect, type ReactNode } from 'react';

import { initDatadogRum } from '@/utils/datadog-init';

export function DatadogRumProvider({ children }: Readonly<{ children: ReactNode }>) {
  useEffect(() => {
    initDatadogRum();
  }, []);

  return <>{children}</>;
}
